import React, { createContext, useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { precioPais } from "../controller/api";

// Crear el contexto
export const MyContext = createContext(null);

// Provider
export const MyProvider = ({ children }) => {
  const [state, setState] = useState("Valor inicial");
  const [formData, setFormData] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [step, setStep] = useState(1);
  const [user, setUser] = useState(JSON.parse(localStorage.getItem("user")) || null);
  const [precio, setPrecio] = useState(JSON.parse(localStorage.getItem("precio")) || null);

  const navigate = useNavigate();
  const userTipo = user?.tipoUser || "";

  // Función para abrir y cerrar el modal
  const toggleModal = () => setIsModalOpen(!isModalOpen);

  // Redirección
  const redirectToHome = () => navigate("/");

  // ✅ Obtener precio actualizado desde API
  const fetchPreciosPais = useCallback(async () => {
    try {
      if (!user?.pais) return;
      const data = await precioPais(user.pais);
      const precioRedondeado = Math.ceil(data.hora_trabajo);
      setPrecio(precioRedondeado);
      localStorage.setItem("precio", JSON.stringify(precioRedondeado));
    } catch (error) {
      console.error("Error al obtener precios por país:", error);
    }
  }, [user]);

  // ✅ Cuando se abre/cierra el modal, refrescar datos del usuario
  useEffect(() => {
    if (!user) return;

    if (isModalOpen) {
      // Al abrir el modal: resetear precio y recargar
      localStorage.setItem("precio", JSON.stringify(1));
      setPrecio(1);
      fetchPreciosPais();
    } else {
      // Al cerrar el modal: refrescar precio real
      fetchPreciosPais();
    }
  }, [isModalOpen, user, fetchPreciosPais]);

  // ✅ Mantener sincronizado el usuario del localStorage
  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    if (storedUser && !user) {
      setUser(storedUser);
    }
  }, [user]);

  return (
    <MyContext.Provider
      value={{
        state,
        setState,
        formData,
        setFormData,
        redirectToHome,
        isModalOpen,
        setIsModalOpen,
        toggleModal,
        user,
        setUser, // ✅ ahora disponible
        userTipo,
        step,
        setStep,
        precio,
        setPrecio,
      }}
    >
      {children}
    </MyContext.Provider>
  );
};
